import type { CSSProperties } from "react";
import { useState } from "react";
import { cn } from "../lib/utils";

export interface KVItem {
  key: string;
  value: string | number;
  copyable?: boolean;
}

type KVLayout = "horizontal" | "vertical";

interface KeyValueProps {
  items: KVItem[];
  layout?: KVLayout;
  separator?: string;
  className?: string;
  style?: CSSProperties;
}

export function KeyValue({
  items,
  layout = "horizontal",
  separator = ":",
  className,
  style,
}: KeyValueProps) {
  const [copied, setCopied] = useState<string | null>(null);

  async function copy(key: string, value: string) {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(key);
      setTimeout(() => setCopied(null), 1500);
    } catch {
      // clipboard unavailable
    }
  }

  return (
    <dl className={cn("kv-list", `kv-${layout}`, className)} style={style}>
      {items.map(item => (
        <div key={item.key} className="kv-row">
          <dt className="kv-key">
            {item.key}
            {separator && <span className="kv-sep">{separator}</span>}
          </dt>
          <dd className="kv-val">
            <span>{item.value}</span>
            {item.copyable && (
              <button
                type="button"
                className="kv-copy"
                title="Copy"
                onClick={() => copy(item.key, String(item.value))}
              >
                {copied === item.key ? (
                  <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                    <path d="M1 6l3 3 6-6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                ) : (
                  <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                    <rect x="4" y="4" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="1.2"/>
                    <path d="M3 8H2a1 1 0 01-1-1V2a1 1 0 011-1h5a1 1 0 011 1v1" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/>
                  </svg>
                )}
              </button>
            )}
          </dd>
        </div>
      ))}
    </dl>
  );
}
